import { cloneDeep } from '@sama/micro-dash';
import { addPoints } from '../../../../shared/misc-utilities/point-utils';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { SingleSubpointTranslationHelper } from '../../tools/edit/single-subpoint-translation-helper';

export class RectangleSubpointTranslationHelper extends SingleSubpointTranslationHelper {
  protected override getMovableSubpointIndexes() {
    const sameX = 3 - this.pointIndex;
    const sameY = (5 - this.pointIndex) % 4;
    return [this.pointIndex, sameX, sameY];
  }

  protected override movePoints(oldPoints: Point2D[], delta: Point2D) {
    const movableSubpoints = this.getMovableSubpointIndexes();
    const points = cloneDeep(oldPoints);
    points[movableSubpoints[0]] = addPoints(points[movableSubpoints[0]], delta);
    points[movableSubpoints[1]][0] = points[movableSubpoints[0]][0];
    points[movableSubpoints[2]][1] = points[movableSubpoints[0]][1];
    return points;
  }
}
